import * as d3 from "d3";

export default {
    data() {
        return {
            const: {
                entityTypes: [
                    "",
                    "ORG",
                    "CARDINAL",
                    "DATE",
                    "GPE",
                    "PERSON",
                    "MONEY",
                    "PRODUCT",
                    "TIME",
                    "PERCENT",
                    "WORK_OF_ART",
                    "QUANTITY",
                    "NORP",
                    "LOC",
                    "EVENT",
                    "ORDINAL",
                    "FAC",
                    "LAW",
                    "LANGUAGE",
                ],
                entityColors: [
                    "#fff",
                    "#f28e2c",
                    "#17becf",
                    "#499894",
                    "#59a14e",
                    "#76b7b2",
                    "#f7b6d2",
                    "#e377c2",
                    "#c49c94",
                    "#8c564b",
                    "#4e79a7",
                    "#b07aa2",
                    "#e15759",
                    "#ff9da7",
                    "#98df8a",
                    "#A0CBE8",
                    "#ffbb78",
                    "#B6992D",
                    "#9c755f",

                ],
                entityParts: [
                    { value: "B", text: "begins Entity" },
                    { value: "I", text: "extends Entity" },
                    // { value: "O", text: "not Part of Entity", disabled: true },
                ]
            }
        }
    },
    computed: {
        entityColorScale: function () {
            const colorScale = d3.scaleOrdinal()
                .domain(this.const.entityTypes)
                .range(this.const.entityColors)

            return colorScale
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/constantsMixin.js